var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67827 8.83592L3.40222 7.78992C3.25523 7.76542 3.13251 7.66425 3.08038 7.52467L0.91546 1.72684C0.708235 1.19392 1.26609 0.685585 1.77748 0.941252L16.7774 8.44125C17.2381 8.67159 17.2381 9.329 16.7774 9.55933L1.77748 17.0593C1.26609 17.315 0.708235 16.8066 0.91546 16.2738L3.08038 10.4759C3.13251 10.3363 3.25523 10.2352 3.40222 10.2107L9.67827 9.16467C9.76902 9.14959 9.83035 9.06367 9.81527 8.97292C9.80352 8.90267 9.74852 8.84758 9.67827 8.83592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane01);
export default __webpack_public_path__ + "static/media/paper-plane-01.929ca263f2c7fe932c08058db81e8d28.svg";
export { ForwardRef as ReactComponent };